module.exports = __webpack_public_path__ + "img/logo.632a783c.png";